import { Card } from '@/components/ui/card';
import { CreditCard, Wallet, Building2, Smartphone, Globe, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const depositMethods = [
  {
    category: 'Cards',
    icon: CreditCard,
    methods: ['Visa', 'Mastercard', 'Maestro'],
    color: 'from-blue-500 to-blue-600',
  },
  {
    category: 'Crypto',
    icon: Wallet,
    methods: ['USDT (TRC20)', 'Bitcoin', 'Ethereum'],
    color: 'from-orange-500 to-orange-600',
  },
  {
    category: 'E-Wallets',
    icon: Smartphone,
    methods: ['Skrill', 'Neteller', 'Perfect Money'],
    color: 'from-purple-500 to-purple-600',
  },
  {
    category: 'Bank Transfer',
    icon: Building2,
    methods: ['Wire Transfer', 'SEPA', 'Local Bank'],
    color: 'from-green-500 to-green-600',
  },
  {
    category: 'Regional',
    icon: Globe,
    methods: ['UPI', 'PayTM', 'Local Options'],
    color: 'from-pink-500 to-pink-600',
  },
];

export const DepositMethodsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Your Money, Your Way
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Fast deposits, instant withdrawals. Choose from multiple secure payment methods.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-5xl mx-auto mb-10">
          {depositMethods.map((method, index) => (
            <Card 
              key={index} 
              className="p-5 text-center hover:shadow-lg transition-all duration-300 border-gray-200 group hover:border-primary/30"
            >
              <div className={`w-14 h-14 mx-auto mb-4 bg-gradient-to-r ${method.color} rounded-xl flex items-center justify-center transform group-hover:scale-110 transition-transform`}>
                <method.icon className="h-7 w-7 text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{method.category}</h3>
              <div className="space-y-1">
                {method.methods.map((m, idx) => (
                  <p key={idx} className="text-xs text-gray-500">{m}</p>
                ))}
              </div>
            </Card>
          ))}
        </div>

        {/* Key Benefits */}
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 max-w-4xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-white">
            <div>
              <div className="text-3xl font-bold text-primary mb-1">0%</div>
              <div className="text-sm text-gray-400">Deposit Fees</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary mb-1">Instant</div>
              <div className="text-sm text-gray-400">Processing</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary mb-1">24/7</div>
              <div className="text-sm text-gray-400">Availability</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary mb-1">Secure</div>
              <div className="text-sm text-gray-400">Transactions</div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link to="/accounts/funding">
            <Button variant="outline" className="font-semibold">
              View All Payment Methods
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DepositMethodsSection;
